import React, { useState } from "react";
import { motion } from "framer-motion";
import { SelfCheckOptionType } from "pages/self-check/SelfCheck";

/**
 * @deprecated
 */
export function SelectButtonCircle({
  selected,
  option,
  disable,
  handleClick,
}: {
  selected: boolean;
  option: SelfCheckOptionType;
  disable: boolean;
  handleClick: (option: SelfCheckOptionType) => void;
}) {
  const [buttonDown, setButtonDown] = useState(false);

  return (
    <div
      className={`flex flex-col items-center w-[47px] relative`}
      onMouseDown={(e) => {
        setButtonDown(true);
      }}
      onClick={(e) => {
        handleClick(option);
      }}
      onTouchStart={(e) => {
        console.log("touchstart");
        setButtonDown(true);
      }}
      onTouchEnd={(e) => {
        console.log("touchend");
        setButtonDown(false);
        if (
          document
            .elementsFromPoint(
              e.changedTouches[0].clientX,
              e.changedTouches[0].clientY
            )
            .includes(e.currentTarget) &&
          !disable
        ) {
          handleClick(option);
        }
      }}
    >
      <motion.div
        animate={{ scale: buttonDown && !disable ? 0.95 : 1 }}
        transition={{ duration: 0.2 }}
      >
        <div
          className={`w-[47px] h-[47px] rounded-[47px] 
                mb-[10px] flex justify-center items-center
                bg-white border
            ${
              selected
                ? `border-[#0F55A7]` // theme.vars.palette.Surface.Highlight
                : `border-[#E6EFF2]` // theme.vars.palette.Surface.Backward
            }`}
        >
          <div
            className={`w-[25px] h-[25px] rounded-[25px] bg-[#E6EFF2]`} // theme.vars.palette.Surface.Backward
          >
            <div
              className={`w-full h-full rounded-[25px] bg-[#0F55A7] ${
                // theme.vars.palette.Content.Highlight
                selected ? "scale-100" : "scale-0"
              } transition-all`}
            />
          </div>
        </div>
      </motion.div>
      <div
        className={`select-none text-[15px] leading-[21px] whitespace-nowrap ${
          selected
            ? "font-bold text-[#0F55A7]" // fontWeight: 700, color: theme.vars.palette.Content.Highlight
            : "font-medium text-[#20272B]" // fontWeight: 500, color: theme.vars.palette.Content.Strong
        }`}
      >
        {option.text}
      </div>
    </div>
  );
}